export const getUserPermissionInfoText = (action: string): string => {
  return `You don't have permission to ${action}. Contact your administrator to request access.`;
};
